// extracted by mini-css-extract-plugin
module.exports = {"styledModal":"j_B3xyGo","content":"DjE9Tpp6","sources":"pO_SOZQu","resetDescription":"AO5UCvfw"};